import { render, staticRenderFns } from "./PromotionTablePane.vue?vue&type=template&id=48f9d9ac&scoped=true"
import script from "./PromotionTablePane.vue?vue&type=script&lang=js"
export * from "./PromotionTablePane.vue?vue&type=script&lang=js"
import style0 from "./PromotionTablePane.vue?vue&type=style&index=0&id=48f9d9ac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f9d9ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48f9d9ac')) {
      api.createRecord('48f9d9ac', component.options)
    } else {
      api.reload('48f9d9ac', component.options)
    }
    module.hot.accept("./PromotionTablePane.vue?vue&type=template&id=48f9d9ac&scoped=true", function () {
      api.rerender('48f9d9ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/promotion/PromotionTablePane.vue"
export default component.exports